// eslint-disable-next-line import/named
import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { getEasing } from '../../utils/getEasing';
function isHeadline(variant) {
    return [
        'order1',
        'order2',
        'order3',
        'order4',
        'display1',
        'display2',
    ].includes(variant);
}
function getVariantColor(variant, theme) {
    switch (variant) {
        case 'order1':
        case 'display1':
        case 'display2':
            return theme.colors.text.primary;
        default:
            return theme.colors.text.secondary;
    }
}
export const StyledText = styled.span `
  margin: 0;

  color: ${(props) => getVariantColor(props.variant, props.theme)};
  font-weight: ${(props) => props.theme.fontWeights[props.weight]};
  font-style: normal;
  letter-spacing: ${(props) => isHeadline(props.variant) && '-0.015em'};
  text-decoration: none;

  ${(props) => injectTypography(props, props.variant)}

  ${injectOSXFontSmoothing(true)}
  ${injectSpacing('margin')}

  /* Prevent italic styles on nested elements */
  i,
  em {
    font-style: inherit;
  }

  a {
    padding-bottom: 0.06125em;

    color: inherit;
    font-weight: ${(props) => props.theme.fontWeights.bold};
    text-decoration: none;

    border-bottom: 1px solid
      ${(props) => props.theme.colors.utility.neutral['30']};

    transition: 250ms ${getEasing};
    transition-property: color border-color;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.colors.text.primary};

      border-bottom-color: ${(props) => props.theme.colors.text.primary};
    }
  }
`;
//# sourceMappingURL=Text.styles.js.map